/**
 * PageHome Component
 * Connected to redux
 * 
 * @prop gui {String}
 *  ['desktop'|'mobile']
 * @state {Object}
 *  .navPath {String}
 */

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { connect } from "react-redux";

import appStore from '../../redux/store/appStore';
import {
    storeReset,
    updateUser
} from '../../redux/actions/actions';

import Header from '../Header';
import PageHomeContent from './PageHomeContent';
import GoogleLibUnavailable from './GoogleLibUnavailable';

import { gaTrackPage } from '../../helpers/google-analytics-helper';
import { navigationByWizardControlsStart } from '../../helpers/browser-navigation-helper';
import { initialize as autocompleteInitialize } from '../../helpers/google-places-autocomplete-helper';
import { warn as guiFeedbackWarn } from '../../libs/gui-feedback';
import getResponsiveContent from '../../helpers/responsive-content-helper';

import { pageComponentCssClass } from '../../helpers/components-helper';

import './Page.css';
import './PageHome.css';

const mapStateToProps = state => {
    return {
        gui: state.gui
    };
};

const title = 'Disegna il tuo futuro solare';
const infos = `Partendo dalle caratteristiche del tuo immobile e dei tuoi consumi, dagli obiettivi di indipendenza che ti sei prefissato di raggiungere, dalle tue priorità e il valore dell’investimento che sei disposto a sostenere, attraverso la nostra piattaforma progettuale, saremo in grado di consigliarti la migliore soluzione progettuale per diventare soggetto attivo della transizione energetica, essenziale per il futuro del nostro pianeta.<br />Pochi e semplici passaggi:`;
const btnTxt = 'Inizia';

class PageHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            navPath: null
        };
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        appStore.dispatch(storeReset());
        // Google Analytics track page
        gaTrackPage();
    }

    autocompleteInit() {
        try {
            const autocomplete = autocompleteInitialize({
                element: document.getElementById('user-address')
            });
        } catch (e) {
            console.error(e.name + ': ' + e.message);
        }
    }

    onSubmit() {

        const userAddress = document.getElementById('user-address').value;
        const userEmail = document.getElementById('user-email').value;

        if (userAddress === '') {
            guiFeedbackWarn('E\' necessario inserire un indirizzo');
            return;
        }

        appStore.dispatch(updateUser({
            address: userAddress,
            email: userEmail
        }));
        navigationByWizardControlsStart();
        this.setState((state, props) => ({
            navPath: '/wizard'
        }));
        
    }

    /**
     * Returns the page css class name
     * @return {String}
     *  Sample
     *      'slc-page slc-page-home responsive-desktop
     */
    pageClassName () {
        return pageComponentCssClass('home', this.props.gui.responsive);
    }

    googleLibUnavailableClassName () {
        return (!this.props.googleLib)
            ? ' slc-page-home--google-lib-unavailable'
            : '';
    }

    render() {
        if (this.state.navPath) {
            return <Redirect to={ {pathname: this.state.navPath} } />
        } else {
            return (
                <div className={ this.pageClassName() + this.googleLibUnavailableClassName() }>
                    <div className="row slc-page-header">
                        <div className="col s12">
                            <Header title={false} />
                        </div>
                    </div>
                    <div className="slc-page-body">
                        { this.props.googleLib
                            ? (
                                <PageHomeContent
                                responsive={ this.props.gui.responsive }
                                onSubmit={ this.onSubmit }
                                autocompleteInit={ this.autocompleteInit }
                                title={ title }
                                infos={ infos }
                                btnTxt={ getResponsiveContent('homeBtnTxt', this.props.gui.responsive) }
                                imagePath={ getResponsiveContent('homeImage', this.props.gui.responsive) } />
                            ) : (
                                <GoogleLibUnavailable />
                            )
                        }
                    </div>
                    <div className="slc-page-footer">
                        <div className='slc-page-footer__image' />
                    </div>
                </div>
            );
        }
    }
    
};

export default connect(mapStateToProps)(PageHome);

export {
    PageHome
}